module.exports = __webpack_public_path__ + "287b81e6e593204f8a6f014a416b107e.svg";